import {Component, Input} from '@angular/core';
import {contextColors} from '../../@theme/theme-colors';

@Component({
    selector: 'app-illustration-message',
    template: `
        <app-illustration [size]="size" [icon]="icon" [iconName]="iconName" [hasTrees]="hasTrees" [circleColor]="circleColor"></app-illustration>
        <div style="max-width: 600px">
            <ng-container *ngIf="size === 'xl'">
                <h3 style="font-weight: 800; font-size: 2.5em; text-transform: uppercase;" class="text-primary">{{title}}</h3>
                <p style="font-weight: 700" class="text-muted">{{caption}}</p>
            </ng-container>
            <div *ngIf="size !== 'xl'"
                 [class.mb-5]="size === 'lg'"
                 [class.mb-4]="size === 'md'"
                 [class.mb-3]="size === 'sm'">
                <div [class.h4]="size === 'lg'"
                     [class.h5]="size === 'md'"
                     [class.h6]="size === 'sm'"
                     class="text-muted">
                    {{title}}
                </div>
                <div *ngIf="caption"
                     [class.small]="size !== 'lg'"
                     [class.mt-4]="size === 'lg'"
                     [class.mt-3]="size === 'md'"
                     [class.mt-2]="size === 'sm'"
                     class="text-muted">
                    {{caption}}
                </div>
            </div>
            <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./illustration-message.component.scss'],
})
export class IllustrationMessageComponent {
    @Input() size: 'xl' | 'lg' | 'md' | 'sm' = 'xl';
    @Input() title: string;
    @Input() caption: string;
    @Input() iconName: string;
    @Input() icon: {far: any; fas: any};
    @Input() hasTrees = false;
    @Input() circleColor = [contextColors.brand_3, .4];
}
